import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, UseFormReturn } from 'react-hook-form'
import { object } from 'yup'

import { usePersonGeneralData } from 'hooks'
import { useGetAddressByCep } from 'hooks/useGetAddressByCep'
import { FamilyContact, ModifiedAddress } from 'models/Auth'
import { addressSchema, familyContactSchema } from 'utils/schemas'

interface FormValues {
  address: ModifiedAddress
  familyContact: FamilyContact
}

export type AddressAndFamilyContactFormMethods = UseFormReturn<FormValues>

export const completeSchema = object().shape({
  address: addressSchema,
  familyContact: familyContactSchema
})

export const useAddressAndFamilyContactForm = (): AddressAndFamilyContactFormMethods => {
  const { userData } = usePersonGeneralData()
  
  const formMethods = useForm({
    criteriaMode: 'all',
    mode: 'all',
    resolver: yupResolver(completeSchema),
    defaultValues: {
      address: {
        cep: userData.address_data?.cep || '',
        address: userData.address_data?.address || '',
        number: userData.address_data?.address_number || '',
        complement: userData.address_data?.complement || '',
        neighborhood: userData.address_data?.neighborhood || '',
        city: userData.address_data?.city || '',
        state: userData.address_data?.state || ''
      },
      familyContact: {
        fullName: userData.relative_data?.relative_full_name || '',
        relationship: userData.relative_data?.relationship_degree || null,
        phone: userData.relative_data?.relative_phone_number || ''
      }
    }
  })

  const { setValue, setError, watch } = formMethods
  const cep = watch('address.cep')
  useGetAddressByCep({
    cep,
    enabled: cep?.length === 8,
    onSuccess: (data) => {
      setValue('address.address', data.address, { shouldValidate: true })
      setValue('address.neighborhood', data.neighborhood, { shouldValidate: true })
      setValue('address.city', data.city, { shouldValidate: true })
      setValue('address.state', data.state, { shouldValidate: true })
    },
    onError: () => {
      setError('address.cep', {
        type: 'manual',
        message: 'CEP inválido'
      })
      setValue('address.address', '')
      setValue('address.neighborhood', '')
      setValue('address.city', '')
      setValue('address.state', '')
    }
  })

  return formMethods
}